// FACILITIES
const GET_FACILITIES_REQUEST = "GET_FACILITIES_REQUEST";
const GET_FACILITIES_COMPLETED = "GET_FACILITIES_COMPLETED";
const GET_FACILITIES_ERROR = "GET_FACILITIES_ERROR";

const GET_FACILITY_REQUEST = "GET_FACILITY_REQUEST";
const GET_FACILITY_COMPLETED = "GET_FACILITY_COMPLETED";
const GET_FACILITY_ERROR = "GET_FACILITY_ERROR";

const UPDATE_FACILITY_REQUEST = "UPDATE_FACILITY_REQUEST";
const UPDATE_FACILITY_COMPLETED = "UPDATE_FACILITY_COMPLETED";
const UPDATE_FACILITY_ERROR = "UPDATE_FACILITY_ERROR";

const GET_FULL_FACILITY_REQUEST = "GET_FULL_FACILITY_REQUEST";
const GET_FULL_FACILITY_COMPLETED = "GET_FULL_FACILITY_COMPLETED";
const GET_FULL_FACILITY_ERROR = "GET_FULL_FACILITY_ERROR";

const CREATE_FACILITY_REQUEST = "CREATE_FACILITY_REQUEST";
const CREATE_FACILITY_COMPLETED = "CREATE_FACILITY_COMPLETED";
const CREATE_FACILITY_ERROR = "CREATE_FACILITY_ERROR";

const GET_ORGANIZATIONS_REQUEST = "GET_ORGANIZATIONS_REQUEST";
const GET_ORGANIZATIONS_COMPLETED = "GET_ORGANIZATIONS_COMPLETED";
const GET_ORGANIZATIONS_ERROR = "GET_ORGANIZATIONS_ERROR";

const GET_MUNICIPALS_REQUEST = "GET_MUNICIPALS_REQUEST";
const GET_MUNICIPALS_COMPLETED = "GET_MUNICIPALS_COMPLETED";
const GET_MUNICIPALS_ERROR = "GET_MUNICIPALS_ERROR";

const GET_DEPARTMENTS_REQUEST = "GET_DEPARTMENTS_REQUEST";
const GET_DEPARTMENTS_COMPLETED = "GET_DEPARTMENTS_COMPLETED";
const GET_DEPARTMENTS_ERROR = "GET_DEPARTMENTS_ERROR";

const EDIT_DEPARTMENTS_REQUEST = "EDIT_DEPARTMENTS_REQUEST";
const EDIT_DEPARTMENTS_COMPLETED = "EDIT_DEPARTMENTS_COMPLETED";
const EDIT_DEPARTMENTS_ERROR = "EDIT_DEPARTMENTS_ERROR";

const ADD_IMAGES_COMPLETED = "ADD_IMAGES_COMPLETED";
const ADD_IMAGES_ERROR = "ADD_IMAGES_ERROR";

const DELETE_FACILITIES_REQUEST = "DELETE_FACILITIES_REQUEST";
const DELETE_FACILITIES_COMPLETED = "DELETE_FACILITIES_COMPLETED";
const DELETE_FACILITIES_ERROR = "DELETE_FACILITIES_ERROR";

const DELETE_IMAGE_REQUEST = "DELETE_IMAGE_REQUEST";
const DELETE_IMAGE_COMPLETED = "DELETE_IMAGE_COMPLETED";
const DELETE_IMAGE_ERROR = "DELETE_IMAGE_ERROR";

export default {
  GET_FACILITIES_REQUEST,
  GET_FACILITIES_COMPLETED,
  GET_FACILITIES_ERROR,
  GET_FACILITY_REQUEST,
  GET_FACILITY_COMPLETED,
  GET_FACILITY_ERROR,
  GET_FULL_FACILITY_REQUEST,
  GET_FULL_FACILITY_COMPLETED,
  GET_FULL_FACILITY_ERROR,
  CREATE_FACILITY_REQUEST,
  CREATE_FACILITY_COMPLETED,
  CREATE_FACILITY_ERROR,
  UPDATE_FACILITY_REQUEST,
  UPDATE_FACILITY_COMPLETED,
  UPDATE_FACILITY_ERROR,
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_COMPLETED,
  GET_ORGANIZATIONS_ERROR,
  GET_MUNICIPALS_REQUEST,
  GET_MUNICIPALS_COMPLETED,
  GET_MUNICIPALS_ERROR,
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_COMPLETED,
  GET_DEPARTMENTS_ERROR,
  EDIT_DEPARTMENTS_REQUEST,
  EDIT_DEPARTMENTS_COMPLETED,
  EDIT_DEPARTMENTS_ERROR,
  ADD_IMAGES_COMPLETED,
  ADD_IMAGES_ERROR,
  DELETE_FACILITIES_REQUEST,
  DELETE_FACILITIES_COMPLETED,
  DELETE_FACILITIES_ERROR,
  DELETE_IMAGE_REQUEST,
  DELETE_IMAGE_COMPLETED,
  DELETE_IMAGE_ERROR
}
